import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About';
import Projects from './pages/Projects';
import NestProject from './pages/NestProject';
import Contact from './pages/Contact';
import './index.css';
import LeaderProfilePage from './pages/LeaderProfilePage';
import Layout from './components/layout/Layout';
import Interior from './pages/interactivewalkthrough/Interior';
import Exterior from './pages/interactivewalkthrough/Exterior';
function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/ongoing-projects" element={<NestProject />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/interactive-walkthrough/interior" element={<Interior />} />
        <Route path="/interactive-walkthrough/exterior" element={<Exterior />} />
        <Route 
          path="/:leaderName" 
          element={
            <Layout>
              <LeaderProfilePage />
            </Layout>
          } 
        />
      </Routes>
    </Router>
  );
}


export default App;